import { Form } from 'react-bootstrap';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '@/app/hook';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { handleUpdateAppearanceItem } from './appearanceSlice';
import { IAiAppearance } from './types';

type Props = {
  register: UseFormRegister<IAiAppearance>;
  errors: FieldErrors<IAiAppearance>;
};

function AppearanceDisplayName({ register, errors }: Props) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  return (
    <>
      <div className="tw-self-stretch tw-flex-col tw-justify-start tw-items-start tw-gap-5 tw-flex">
        <Form.Group className="tw-w-full  tw-flex  tw-flex-col ">
          <Form.Label className="tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
            {t('DashboardSettingCustomizeChat/l-23')}
          </Form.Label>

          <Form.Control
            maxLength={30}
            isInvalid={!!errors.displayedName}
            {...register('displayedName', {
              onChange: event => {
                dispatch(
                  handleUpdateAppearanceItem({
                    key: 'displayedName',
                    value: event.target.value != '' ? event.target.value : null,
                  })
                );
              },
            })}
            className="tw-h-10 tw-px-4 tw-py-2.5 tw-bg-white tw-rounded-md tw-shadow-sm tw-border tw-border-gray-300 tw-justify-start tw-items-center tw-inline-flex"
          />
          <Form.Control.Feedback type="invalid" className="d-block font-poppins">
            {errors?.displayedName?.message as string}
          </Form.Control.Feedback>
        </Form.Group>
      </div>
      <hr className="tw-border-gray-200 tw-pb-6 ty-m-0" />
    </>
  );
}

export default WrappedErrorBoundary(AppearanceDisplayName);
